import { createFileRoute } from '@tanstack/react-router';

type Search = {
  contactId?: string;
  selectedLocationId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/fax/drafts/new-from-template')({
  validateSearch: (search: Partial<Search>): Search => {
    return {
      contactId: search.contactId,
      selectedLocationId: search.selectedLocationId,
    };
  },
});
